import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArrayStrings(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M3 4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H5v14h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1V4ZM21 20a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h3V5h-3a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v16Z"
      />
      <path
        fill="currentColor"
        d="M16 9H8s-1 0-1 1 1 1 1 1h8s1 0 1-1-1-1-1-1ZM12 13H8s-1 0-1 1 1 1 1 1h4s1 0 1-1-1-1-1-1Z"
      />
    </BaseIcon>
  );
}
